import React, { useState } from 'react'
import { ContainerDeleteProject } from '../../../../components/container/ContainerDeleteProject';
import { deletePermanentProyect, unlinkProyect } from '../../../../config';
import { msgErrorNotfication } from '../../../../helpers/errorResponseHelpers';

export const ModalDeleteProject = ({ modalDeleteProyect, closeModal, updateResponse }) => {
    const [disableButton, setDisableButton] = useState(true);
    const [loading, setLoading] = useState(false);

    const comparativeTextVSpaceId = (event) => {
        const { target: { value } } = event
        setDisableButton(value !== modalDeleteProyect.name);
    };

    const msgErrorDelete = (payload = []) => {
        if (payload.length === 0) return false
        const { text, type } = payload[0]
        msgErrorNotfication(type, text)
        return false
    }

    const deletePermanentProject = async (clickupSpace) => {
        const { status, payload = [] } = await deletePermanentProyect(clickupSpace)
        if (status > 0) return msgErrorDelete(payload)
        return true
    };

    const desunlinkProject = async (clickupSpace) => {
        const { status, payload = [] } = await unlinkProyect(clickupSpace)
        if (status > 0) return msgErrorDelete(payload)
        return true
    };


    const finishForm = async () => {
        setLoading(true);
        const { type = "", clickupSpace } = modalDeleteProyect
        try {
            const actionsDelete = {
                "unlink": (spaceId) => desunlinkProject(spaceId),
                "delete": (spaceId) => deletePermanentProject(spaceId),
            }[type]

            if (!actionsDelete) return

            const reloadPage = await actionsDelete(clickupSpace)

            if (!reloadPage) return

            updateResponse()
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
            setDisableButton(true)
            closeModal();
        }
    };


    return (
        <ContainerDeleteProject
            type={modalDeleteProyect.type}
            isOpen={modalDeleteProyect.active}
            name={modalDeleteProyect.name}
            disableButton={disableButton}
            onInputChange={comparativeTextVSpaceId}
            onCancel={closeModal}
            onConfirm={finishForm}
            loading={loading}
        />
    )
}
